// extracted by mini-css-extract-plugin
export default {"disabled":"CpeETn","id_model":"nxKCvU","idModel":"nxKCvU"};